import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["aria-controls", "aria-label", "disabled"]
const _hoisted_2 = ["aria-controls", "aria-label", "onClick"]
const _hoisted_3 = { class: "sr-only" }
const _hoisted_4 = ["aria-controls", "aria-label", "disabled"]
const _hoisted_5 = ["aria-roledescription"]
const _hoisted_6 = ["aria-current"]
const _hoisted_7 = ["href", "title", "data-tag-label"]
const _hoisted_8 = { class: "w-full space-y-4 py-6 sm:p-10 md:w-1/2" }
const _hoisted_9 = {
  key: 1,
  class: "flex space-x-2"
}
const _hoisted_10 = ["href", "title", "data-tag-label"]

import { ref, watchEffect, nextTick, computed, onMounted } from "vue";

import { getIcon } from "~/js/composables/icons";
import { getClasses } from "~/js/composables/classes";

import { Content } from "~/js/interfaces/media";

import TextH3 from "~/vue/atoms/texts/TextH3.vue";
import TextProse from "~/vue/atoms/texts/TextProse.vue";
import TextBody from "~/vue/atoms/texts/TextBody.vue";
import ImageContent from "~/vue/atoms/images/ImageContent.vue";
import Badge from "~/vue/atoms/badges/BadgePrimary.vue";

interface Testimonials {
	title: string;
	prose: string;
	friendlyName: string;
	jobTitle: string | null;
	caption: string | null;
	image: Content;
}

interface A11Y {
	title: string;
	previous: string;
	next: string;
}

interface Props {
	heading?: string | null;
	headingColor?: string | null;
	animate?: boolean;
	prose?: string | null;
	testimonials: Testimonials;
	a11y: A11Y;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SliderTestimonials',
  props: {
    heading: { default: null },
    headingColor: { default: null },
    animate: { type: Boolean, default: false },
    prose: { default: null },
    testimonials: {},
    a11y: {}
  },
  setup(__props: any) {

const props = __props;

const classes = ref({
	container: {
		animation: "transition-transform duration-700 ease-in-out",
		flex: "flex shrink-0",
		size: "w-screen",
	},
	controls: {
		flex: "flex items-center justify-end",
		size: "w-full",
		space: "space-x-4",
	},
	dotsContainer: {
		display: "hidden sm:flex",
		space: "space-x-1",
	},
	dots: {
		animation: "transition-all",
		display: "inline-flex",
		background: "bg-viridian-500",
		layout: "rounded-full",
		size: "w-3 h-3",
	},
	header: {
		flex: "flex items-center justify-between",
		margin: "mb-4",
		size: "w-full",
		space: "space-x-2",
	},
	imageWrapper: {
		aspect: "aspect-square lg:aspect-video",
		position: "relative",
		size: "w-full md:w-1/2",
	},
	prevnext: {
		background: "bg-viridian-500",
		color: "text-white",
		display: "flex items-center justify-center",
		layout: "rounded-full",
		size: "w-8 h-8",
	},
	prevnextDisabled: {
		background: "bg-concrete-300",
		color: "text-white",
		display: "flex items-center justify-center",
		layout: "rounded-full",
		size: "w-8 h-8",
	},
	scroller: {
		flex: "flex shrink-0",
		oveflow: "scrollbar-hide scroll-smooth snap-mandatory snap-x overflow-x-auto",
		size: "w-screen",
	},
	testimonial: {
		background: "bg-sky-blue-200",
		display: `${props.testimonials.length > 1 ? "container" : ""} max-w-screen-xl`,
		flex: "sm:flex items-center shrink-0",
		padding: "p-4 md:p-10",
		size: "w-[85vw] sm:w-[90vw] 2xl:w-screen",
		layout: "rounded-4xl",
	},
	wrapper: {
		flex: "flex justify-center relative",
		position: "relative",
	},
});
const ghost = ref<null | HTMLElement>(null);
const container = ref<null | HTMLElement>(null);
const scroller = ref<null | HTMLElement>(null);
const margin = ref(0);
// const translate = ref(0)
const activeSlide = ref(0);
const direction = ref("prev");
const reset = ref(false);

const updateSlide = (i: number, prevnext = true) => {
	if (i > activeSlide.value) {
		direction.value = "next";
	} else {
		direction.value = "prev";
	}

	activeSlide.value = i;
	setSpacings();

	if (prevnext) {
		prevNext();
	}

	reset.value = true;

	nextTick(() => {
		reset.value = false;
	});
};

const setSpacings = () => {
	margin.value = ghost.value?.getBoundingClientRect().left;
};

const prevNext = () => {
	const slide = ghost.value?.querySelectorAll(".slider-item")[1];

	if (slide) {
		// const padding = parseInt( (slide.currentStyle || window.getComputedStyle(slide)).paddingLeft ) * .5

		const position =
			direction.value == "prev"
				? scroller.value.scrollLeft - slide.offsetWidth
				: scroller.value.scrollLeft + slide.offsetWidth;

		scroller.value.scroll({
			left: slide.offsetWidth * activeSlide.value,
			top: 0,
			behavior: "smooth",
		});
		// translate.value = (slide?.getBoundingClientRect().width + padding) * (activeSlide.value - 1)
	}
};

const gallery = computed(() => {
	return [...props.videos, ...props.images];
});

const calculateActiveItem = () => {
	let setIndex = false;
	ghost.value.querySelectorAll(".slider-item").forEach((item) => {
		if (item.getBoundingClientRect().left >= 0 && !setIndex) {
			setIndex = true;
			const index = [...ghost.value.querySelectorAll(".slider-item")].indexOf(item);
			if (index !== activeSlide.value) {
				updateSlide(index, false);
			}
		}
	});
};

watchEffect(() => {
	if (scroller.value) {
		scroller.value.addEventListener("scroll", calculateActiveItem);
		calculateActiveItem();
		setSpacings();
	}
});

onMounted(() => {
	window.addEventListener("resize", () => {
		setSpacings();
	});

	setSpacings();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["w-full", __props.animate ? 'animate-slider' : ''])
  }, [
    _createElementVNode("header", {
      class: _normalizeClass(_unref(getClasses)(classes.value, 'header'))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(__props.animate ? 'animate-slider-items' : '')
      }, [
        (__props.heading)
          ? (_openBlock(), _createBlock(TextH3, {
              key: 0,
              utilities: __props.headingColor ?? undefined
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.heading), 1)
              ]),
              _: 1
            }, 8, ["utilities"]))
          : _createCommentVNode("", true)
      ], 2),
      (__props.testimonials.length > 1)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass([_unref(getClasses)(classes.value, 'controls'), __props.animate ? 'animate-slider-items' : ''])
          }, [
            _createElementVNode("button", {
              "aria-controls": __props.a11y.title,
              "aria-label": __props.a11y.previous,
              disabled: activeSlide.value === 0,
              class: _normalizeClass(
						activeSlide.value === 0 ? _unref(getClasses)(classes.value, 'prevnextDisabled') : _unref(getClasses)(classes.value, 'prevnext')
					),
              onClick: _cache[0] || (_cache[0] = () => updateSlide(activeSlide.value > 0 ? activeSlide.value - 1 : activeSlide.value))
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(_unref(getIcon)('chevron-left'))
              }, null, 2)
            ], 10, _hoisted_1),
            _createElementVNode("div", {
              class: _normalizeClass(_unref(getClasses)(classes.value, 'dotsContainer'))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.testimonials, (item, i) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: item.id,
                  "aria-controls": __props.a11y.title,
                  "aria-label": `${i} / ${__props.testimonials.length}`,
                  class: _normalizeClass([_unref(getClasses)(classes.value, 'dots'), i === activeSlide.value ? 'opacity-100' : 'opacity-20']),
                  onClick: () => updateSlide(i)
                }, [
                  _createElementVNode("span", _hoisted_3, _toDisplayString(i) + " / " + _toDisplayString(__props.testimonials.length), 1)
                ], 10, _hoisted_2))
              }), 128))
            ], 2),
            _createElementVNode("button", {
              "aria-controls": __props.a11y.title,
              "aria-label": __props.a11y.next,
              disabled: activeSlide.value === __props.testimonials.length - 1,
              class: _normalizeClass(
						activeSlide.value === __props.testimonials.length - 1
							? _unref(getClasses)(classes.value, 'prevnextDisabled')
							: _unref(getClasses)(classes.value, 'prevnext')
					),
              onClick: _cache[1] || (_cache[1] = () => updateSlide(activeSlide.value < __props.testimonials.length + 1 ? activeSlide.value + 1 : activeSlide.value))
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(_unref(getIcon)('chevron-right'))
              }, null, 2)
            ], 10, _hoisted_4)
          ], 2))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", {
      ref_key: "ghost",
      ref: ghost,
      class: _normalizeClass(_unref(getClasses)(classes.value, 'wrapper'))
    }, [
      _createElementVNode("div", {
        ref_key: "scroller",
        ref: scroller,
        class: _normalizeClass(_unref(getClasses)(classes.value, 'scroller')),
        style: _normalizeStyle({
					paddingRight: `${margin.value}px`,
				})
      }, [
        _createElementVNode("ul", {
          class: _normalizeClass(_unref(getClasses)(classes.value, 'container')),
          style: _normalizeStyle({
						paddingLeft: `${margin.value}px`,
					}),
          "aria-roledescription": __props.testimonials.length > 1 ? 'carousel' : null
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.testimonials, (testimonial, i) => {
            return (_openBlock(), _createElementBlock("li", {
              key: testimonial.heading,
              class: _normalizeClass(["slider-item snap-end", [
							_unref(getClasses)(classes.value, 'testimonial'),
							i > 0 ? 'ml-6 lg:ml-8' : '',
							__props.animate ? 'animate-slider-items' : '',
						]]),
              "aria-current": i + 1 === activeSlide.value,
              role: "listitem"
            }, [
              (testimonial.image.srcset)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(_unref(getClasses)(classes.value, 'imageWrapper'))
                  }, [
                    _createVNode(ImageContent, {
                      image: testimonial.image,
                      ratio: "aspect-square lg:aspect-video",
                      loading: "lazy"
                    }, null, 8, ["image"]),
                    (testimonial.caption)
                      ? (_openBlock(), _createBlock(Badge, {
                          key: 0,
                          style: {
									background: 'bg-black/30',
									text: 'text-white',
								},
                          content: `© ${testimonial.caption}`,
                          utilities: "absolute left-4 bottom-4"
                        }, null, 8, ["content"]))
                      : _createCommentVNode("", true),
                    (testimonial.source.url)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          href: testimonial.source.url,
                          title: testimonial.source.heading,
                          "data-tag-action": "click",
                          "data-tag-category": "testimonial-source",
                          "data-tag-label": testimonial.source.heading,
                          class: "absolute bottom-4 right-4 block",
                          target: "_blank"
                        }, [
                          _createVNode(Badge, {
                            style: {
										background: 'bg-black/30',
										text: 'text-white',
									},
                            content: `<i class="fas fa-external-link"></i><span>${testimonial.source.heading}</span>`,
                            utilities: "block space-x-2"
                          }, null, 8, ["content"])
                        ], 8, _hoisted_7))
                      : _createCommentVNode("", true)
                  ], 2))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(TextH3, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(testimonial.heading), 1)
                  ]),
                  _: 2
                }, 1024),
                (testimonial.prose)
                  ? (_openBlock(), _createBlock(TextProse, {
                      key: 0,
                      html: testimonial.prose
                    }, null, 8, ["html"]))
                  : _createCommentVNode("", true),
                _createVNode(TextBody, { size: "medium" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(testimonial.friendlyName) + " " + _toDisplayString(testimonial.jobTitle ? `- ${testimonial.jobTitle}` : ""), 1)
                  ]),
                  _: 2
                }, 1024),
                (!testimonial.image.srcset)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(Badge, {
                        style: {
										background: 'bg-black/10',
										text: 'text-black',
									},
                        content: `© ${testimonial.caption}`,
                        utilities: "inline-flex"
                      }, null, 8, ["content"]),
                      (testimonial.source.url)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: testimonial.source.url,
                            title: testimonial.source.heading,
                            "data-tag-action": "click",
                            "data-tag-category": "testimonial-source",
                            "data-tag-label": testimonial.source.heading,
                            class: "inline-flex",
                            target: "_blank"
                          }, [
                            _createVNode(Badge, {
                              style: {
											background: 'bg-black/10',
											text: 'text-black',
										},
                              content: `<i class="fas fa-external-link"></i><span>${testimonial.source.heading}</span>`,
                              utilities: "block space-x-2"
                            }, null, 8, ["content"])
                          ], 8, _hoisted_10))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 10, _hoisted_6))
          }), 128)),
          (__props.testimonials.length > 1)
            ? (_openBlock(), _createElementBlock("li", {
                key: 0,
                class: "ml-0 shrink-0 grow-0 items-center sm:flex",
                style: _normalizeStyle({
							width: `${margin.value}px`,
						})
              }, null, 4))
            : _createCommentVNode("", true)
        ], 14, _hoisted_5)
      ], 6)
    ], 2)
  ], 2))
}
}

})